import { AxiosResponse } from "axios";
import { useContext, useEffect, useLayoutEffect, useRef, useState } from "react";
import * as mb from "../../../common/MessageBox";
import { useHistory } from "react-router-dom";
import { getApiData } from "views/utils/CallApi";
import { IFReservationCalendar } from "views/utils/CommonConst";
import { CtxOrder } from "views/utils/Contexts";
import { ReservationCalendar } from "./ReservationCalendar"
import { ReservationSelectDateTimeControl } from "./ReservationSelectDateTimeControl";
import { reloadBlock, scrollTop, sendWindowHeight } from "views/utils/CommonFunc";
import { Error } from "views/guest/pages/error/Error";

export function Reservation(): JSX.Element{

    const history = useHistory();
    const order = useContext(CtxOrder);
    const [msgArgs, setMsgArgs] = useState({type:"", text:""});
    const [isShow1, setIsShow1] = useState<boolean>(false);
    const [isShow2, setIsShow2] = useState<boolean>(false);
    const [isShow3, setIsShow3] = useState<boolean>(false);
    const [rCalendar, setRCalendar] = useState<IFReservationCalendar[]>([]);
    const [loadErr, setLoadErr] = useState("");
    const refWindow = useRef<HTMLDivElement>(null);

    useEffect(function(){

        scrollTop();

        //カート画面を経由していない（ゲスト用セッションがない）場合、エラー
        if (!window.sessionStorage.getItem("guest_access_token")){
            setLoadErr("token_error");
            return;
        }

        order.useStart();

        getApiData('/cart/calendar',
            {},
            function(res:AxiosResponse<any>){
                switch (res.status){
                    case 200:
                        let tmpRCalendar:IFReservationCalendar[] = [];
                        res.data.days_list.forEach(function(day:any){
                            let tmpTimes:any = [];
                            day.calandar_list.forEach(function(time:any){
                                tmpTimes.push({
                                    frame_no: time.frame_no,
                                    schedule_start_time: time.schedule_start_time,
                                    schedule_end_time: time.schedule_end_time,
                                    status: time.status,
                                });
                            });
                            tmpRCalendar.push({
                                date: day.date,
                                schedule_no: day.schedule_no,
                                pattern_id: day.schedule_no,
                                calendar_list: tmpTimes,
                            });
                        });
                        setRCalendar(tmpRCalendar);
                        sendWindowHeight(refWindow);
                        break;
                    default:
                        setLoadErr("api_error");
                }
            }
        );

        //リロード制御
        window.addEventListener('beforeunload', reloadBlock);
        return function(){
            window.removeEventListener('beforeunload', reloadBlock);
        }

    }, []);

    //画面リサイズでウィンドウサイズを呼び出し元に渡す
    useLayoutEffect(function(){
        window.addEventListener('resize', resize);
        return () => window.removeEventListener('resize', resize);
    });
    function resize(){
        sendWindowHeight(refWindow);
    }

    //カレンダーモーダルを表示する
    function clickShowCalendar(idx:number){
        switch (idx){
            case 0:
                setIsShow1(true);
                break;
            case 1:
                setIsShow2(true);
                break;
            case 2:
                setIsShow3(true);
                break;
        }
    }

    //申込情報の入力へ進む
    function clickSubmit(){

        setMsgArgs({type:mb.MSGBOX_TYPE_INFO, text:""});
        //第1希望は必須
        if (!order.data.reserve_date_1){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"第1希望の日時は必ず選択してください。"});
            return;
        }
        //第2希望、第3希望が順番に入力されていない場合はエラー
        if (!order.data.reserve_date_2 && order.data.reserve_date_3){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"第2希望の日時を選択してください。"});
            return;
        }
        //希望日が被っている場合はエラー
        if (order.data.reserve_date_2){
            if ((order.data.reserve_date_1 === order.data.reserve_date_2 && 
                order.data.reserve_start_time_1 === order.data.reserve_start_time_2 &&
                order.data.reserve_end_time_1 === order.data.reserve_end_time_2) 
                || 
                (order.data.reserve_date_1 === order.data.reserve_date_3 && 
                    order.data.reserve_start_time_1 === order.data.reserve_start_time_3 &&
                    order.data.reserve_end_time_1 === order.data.reserve_end_time_3)
                ||
                (order.data.reserve_date_2 === order.data.reserve_date_3 && 
                    order.data.reserve_start_time_2 === order.data.reserve_start_time_3 &&
                    order.data.reserve_end_time_2 === order.data.reserve_end_time_3)){
                setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"希望日時は被らないように選択してください。"});
                return;
            }
        }

        history.push("/guest/guestinfo");

    }

    if (loadErr){
        return (
            <Error type={loadErr}/>
        )
    } else {
        return (
            <>
                <div className="order-main" ref={refWindow} style={{paddingBottom: "200px"}}>
                    <div className="order-width-max">
                        <mb.MessageBox args={msgArgs}/>
                        <div className="order-box">
                            <div className="order-flow">
                                <ul className="order-flow-list">
                                    <li className="is-past">見積内容の選択</li>
                                    <li className="is-current">希望日時の選択</li>
                                    <li>申込情報の入力</li>
                                    <li>申込内容の確認</li>
                                    <li>申込完了</li>
                                </ul>
                            </div>
                            <div className="order-form">
                                <div className="order-form-title">希望日時の選択</div>
                                <div className="msgbox info order-form-reservation-msgbox">
                                    <p>サービス実施の希望日・時間帯を第3希望まで選択してください。</p>
                                    <p className="text-color-red">※選択いただいた日付・時間帯の中でお伺いできる日時を確認し、担当よりご連絡いたします。お申込完了時点では予約日時は確定いたしません。</p>
                                    <p className="text-color-red">※サービスの実施時間は、ご希望の時間帯内に収まらない可能性があります。ご注意ください。</p>
                                </div>
                                <div className="form-row">
                                    <div className="order-select-date">
                                        <ul className="order-select-date-list">
                                            <li>
                                                <div className="order-select-date-title">第1希望</div>
                                                <ReservationSelectDateTimeControl index={0} clickShowCalendar={clickShowCalendar} order={order}/>

                                            </li>
                                            <li>
                                                <div className="order-select-date-title">第2希望</div>
                                                <ReservationSelectDateTimeControl index={1} clickShowCalendar={clickShowCalendar} order={order}/>
                                            </li>
                                            <li>
                                                <div className="order-select-date-title">第3希望</div>
                                                <ReservationSelectDateTimeControl index={2} clickShowCalendar={clickShowCalendar} order={order}/>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="form-row control-horizon control-between">
                                <button className="btn-order btn-secondary btn-icon-left" onClick={function(){history.push("/guest/cart")}}><span className="icon material-icons-round md-18">arrow_back</span>見積内容の確認に戻る</button>
                                <button className="btn-order btn-primary btn-icon-right" onClick={clickSubmit}>申込情報の入力へ進む<span className="icon material-icons-round md-18">arrow_forward</span></button>
                            </div>
                        </div>
                    </div>
                    <ReservationCalendar isShow={isShow1} setIsShow={setIsShow1} index={0} rCalendar={rCalendar} order={order}></ReservationCalendar>
                    <ReservationCalendar isShow={isShow2} setIsShow={setIsShow2} index={1} rCalendar={rCalendar} order={order}></ReservationCalendar>    
                    <ReservationCalendar isShow={isShow3} setIsShow={setIsShow3} index={2} rCalendar={rCalendar} order={order}></ReservationCalendar>
                </div>
            </>
        )
    }
}